module.exports = __webpack_public_path__ + "static/photog-fc9365d5146ebfb1189695a87d7356d6.jpg";